import { ReactNode, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePasswordProtection } from '@/hooks/usePasswordProtection';

interface PasswordProtectionWrapperProps {
  children: ReactNode;
}

const PasswordProtectionWrapper = ({ children }: PasswordProtectionWrapperProps) => {
  const { isProtected, isAuthenticated, isLoading } = usePasswordProtection();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && isProtected && !isAuthenticated && location.pathname !== '/password-protection') {
      // Store intended path
      sessionStorage.setItem('intended_path', location.pathname);
      navigate('/password-protection');
    }
  }, [isProtected, isAuthenticated, isLoading, navigate, location]);

  // Only show loader if we're actually loading AND not authenticated yet
  // This prevents the flash of "verification" message
  if (isLoading && !isAuthenticated && isProtected !== false) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary/50"></div>
      </div>
    );
  }

  return <>{children}</>;
};

export default PasswordProtectionWrapper;
